/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceUnitPriceResponse {
    getFixupPrototypeFunction() { return ResourceUnitPriceResponse.fixupPrototype; }

    static newInstance(model: Partial<ResourceUnitPriceResponse>): ResourceUnitPriceResponse {
        let obj = Object.assign(new ResourceUnitPriceResponse(), model);
        ResourceUnitPriceResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceUnitPriceResponse>): ResourceUnitPriceResponse {
        if (!model) return null;
        return ResourceUnitPriceResponse.newInstance(<ResourceUnitPriceResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceUnitPriceResponse) {
        if (!obj) return;

        models.ResourceUnitPriceResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceUnitPriceResponse): boolean {
        Object.setPrototypeOf(obj, ResourceUnitPriceResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.price === undefined) {
            this.price = 0;
        }
    }

    /**
     * Id of the resource
     */
    key: string;

    /**
     * Price for the resource
     */
    price: number;

    /**
     * Unit value for the resource
     */
    unit: string;

}
